import React, { useEffect, useRef, useState } from 'react';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.css';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import useToken from '../App/useToken';

function Settings() {
    const { token } = useToken();
    const toast = useRef(null);
    const settingKeys = [
        'signup_deadline',
        'first_match_date',
        'playoffs_dieciseisavos_deadline',
        'playoffs_octavos_deadline',
        'playoffs_cuartos_deadline',
        'playoffs_semifinal_deadline',
        'playoffs_tercer_puesto_deadline',
        'playoffs_final_deadline',
    ];

    const emptySettings = {
        signup_deadline: '',
        first_match_date: '',
        playoffs_dieciseisavos_deadline: '',
        playoffs_octavos_deadline: '',
        playoffs_cuartos_deadline: '',
        playoffs_semifinal_deadline: '',
        playoffs_tercer_puesto_deadline: '',
        playoffs_final_deadline: '',
    };

    const [settings, setSettings] = useState(emptySettings);

    useEffect(() => {
        fetch(process.env.REACT_APP_URL + 'settings', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + token,
            },
        })
            .then((response) => response.json())
            .then((data) => {
                const nextSettings = { ...emptySettings };
                data.forEach((item) => {
                    nextSettings[item.key] = formatForInput(item.value);
                });
                setSettings(nextSettings);
            });
    }, []);

    const formatForInput = (value) => {
        if (!value) {
            return '';
        }

        return value.replace(' ', 'T').slice(0, 16);
    };

    const formatForApi = (value) => {
        if (!value) {
            return null;
        }

        return value.replace('T', ' ') + ':00';
    };

    const onChange = (event, key) => {
        setSettings({ ...settings, [key]: event.target.value });
    };

    const saveSettings = () => {
        const payload = {};
        settingKeys.forEach((key) => {
            payload[key] = formatForApi(settings[key]);
        });

        fetch(process.env.REACT_APP_URL + 'settings', {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + token,
            },
            body: JSON.stringify({
                settings: payload,
            }),
        })
            .then((response) => response.json())
            .then((data) => {
                if (data.code === 200) {
                    toast.current.show({ severity: 'success', summary: 'Configuracion', detail: data.mensaje, life: 3000 });
                }
                else {
                    toast.current.show({ severity: 'error', summary: 'Error', detail: data.mensaje || 'No se pudo guardar', life: 4000 });
                }
            });
    };

    return (
        <div className="surface-0 p-4">
            <Toast ref={toast} />
            <div className="mb-4">
                <h2>Configuracion</h2>
                <p>Estas fechas controlan el cierre de registros, fase de grupos y predicciones especiales.</p>
            </div>

            <div className="p-fluid grid">
                <div className="field col-12 md:col-6">
                    <label htmlFor="signup_deadline">Fecha limite de nuevos usuarios</label>
                    <InputText id="signup_deadline" type="datetime-local" value={settings.signup_deadline} onChange={(e) => onChange(e, 'signup_deadline')} />
                </div>

                <div className="field col-12 md:col-6">
                    <label htmlFor="first_match_date">Fecha del primer partido</label>
                    <InputText id="first_match_date" type="datetime-local" value={settings.first_match_date} onChange={(e) => onChange(e, 'first_match_date')} />
                </div>
            </div>

            <div className="mt-4 mb-3">
                <h3>Cierres de playoffs</h3>
                <p>Cada ronda de playoffs cierra completa en la fecha configurada aqui.</p>
            </div>

            <div className="p-fluid grid">
                <div className="field col-12 md:col-6">
                    <label htmlFor="playoffs_dieciseisavos_deadline">Cierre 16avos</label>
                    <InputText id="playoffs_dieciseisavos_deadline" type="datetime-local" value={settings.playoffs_dieciseisavos_deadline} onChange={(e) => onChange(e, 'playoffs_dieciseisavos_deadline')} />
                </div>

                <div className="field col-12 md:col-6">
                    <label htmlFor="playoffs_octavos_deadline">Cierre 8avos</label>
                    <InputText id="playoffs_octavos_deadline" type="datetime-local" value={settings.playoffs_octavos_deadline} onChange={(e) => onChange(e, 'playoffs_octavos_deadline')} />
                </div>

                <div className="field col-12 md:col-6">
                    <label htmlFor="playoffs_cuartos_deadline">Cierre 4tos</label>
                    <InputText id="playoffs_cuartos_deadline" type="datetime-local" value={settings.playoffs_cuartos_deadline} onChange={(e) => onChange(e, 'playoffs_cuartos_deadline')} />
                </div>

                <div className="field col-12 md:col-6">
                    <label htmlFor="playoffs_semifinal_deadline">Cierre semifinal</label>
                    <InputText id="playoffs_semifinal_deadline" type="datetime-local" value={settings.playoffs_semifinal_deadline} onChange={(e) => onChange(e, 'playoffs_semifinal_deadline')} />
                </div>

                <div className="field col-12 md:col-6">
                    <label htmlFor="playoffs_tercer_puesto_deadline">Cierre tercer puesto</label>
                    <InputText id="playoffs_tercer_puesto_deadline" type="datetime-local" value={settings.playoffs_tercer_puesto_deadline} onChange={(e) => onChange(e, 'playoffs_tercer_puesto_deadline')} />
                </div>

                <div className="field col-12 md:col-6">
                    <label htmlFor="playoffs_final_deadline">Cierre final</label>
                    <InputText id="playoffs_final_deadline" type="datetime-local" value={settings.playoffs_final_deadline} onChange={(e) => onChange(e, 'playoffs_final_deadline')} />
                </div>
            </div>

            <Button label="Guardar configuracion" icon="pi pi-save" className="p-button-success" onClick={saveSettings} />
        </div>
    );
}

export default Settings;
